import React from 'react';
import { Link } from 'react-router-dom';

import Alert from 'react-bootstrap/Alert';
import { Eye } from 'react-feather';

import K2Api from 'lib/ajax/K2Api';
import Loader from 'components/Loader';
import AdvancedTable from 'components/LM/common/AdvancedTable';
import { useK2Loader } from 'hooks/useK2Loader';
import Breadcrumb from "components/LM/common/Breadcrumb";

const TABLE_COLUMNS = [
	{
		name: "date",
		alias: "Date"
	},
	{
		name: "filename",
		alias: "Filename"
	},
	{
		name: "user",
		alias: "User"
	},
	{
		name: "status",
		alias: "Status"
	},
	{
		name: "total",
		alias: "Total voices"
	},
	{
		name: "created",
		alias: "Created"
	},
	{
		name: "merged",
		alias: "Merged"
	},
	{
		name: 'details_link',
		alias: ''
	}
];

const DEFAULT_PARAMS = { from: 0, size: 20 };

function OverallStatus(props) {

	const [loading, response, error] = useK2Loader("/voices/import", { params: DEFAULT_PARAMS });

	if (loading) return <Loader />;
	if (error) return <Alert variant="danger">{error.toString()}</Alert>
	return (<>
		{breadcrumbPage()}
		<AdvancedTable
			columns={TABLE_COLUMNS}
			onSearch={params => loadStatuses(params)}
			onResults={response => processResponse(response)}
			data={processResponse(response)}
		/>
	</>)
}

async function loadStatuses({ page, pageSize }) {
	const from = (page - 1) * pageSize;
	const request = { from, size: pageSize };

	const k2Api = new K2Api();
	const response = await k2Api.get(`/voices/import`, { params: request });
	return response.data;
}

function processResponse(response) {
	const total = response.total;
	const rows = response.files.map(file => {
		return {
			id: file.id,
			date: file.date,
			filename: file.filename,
			user: file.user ?? "-",
			status: file.status,
			total: `${file.stats.total}`,
			created: `${file.stats.created}`,
			merged: `${file.stats.merged}`,
			details_link: <DetailLink id={file.id} />
		}
	});
	return { total, rows };
}

function DetailLink(props) {
	return <Link to={`/voices/import/status/${props.id}`}>
		<Eye width="14" height="14" />
	</Link>
}

function breadcrumbPage() {
	const items = [
		'Voices',
		<a href="/voices/import">Mass Import</a>,
		'Import Status'
	  ];
	return <Breadcrumb items={items}/>
}

export default OverallStatus;
